import BaseModel from '../core/BaseModel';

export default class RentalOrderTermModel extends BaseModel {
  constructor() {
    super(
      {
        name: "rental_order_term",
        tableName: 'rental_order_term',
        label: "Renew Contract",
      },
      {
        stt: {
          name: "stt",
          label: "No.",
          type: "Computed",
          computed: (data, index) => {
              data.stt = index + 1;
          },
        },
        id: {
          name: 'id',
          type: "Uuid",
          label: 'ID',
          primaryKey: true,
          unique: true,
          display: false,
        },
        rental_code: {
          name: "color",
          label: "Rental ID",
          type: "Computed",
          filter: { type: 'input', match: 'contains' },
          computed: (data) => {
              data.rental_code = '';
          },
          class: "left",
          width: 8,
        },
        code: {
          name: 'code',
          type: "String",
          label: 'Latest contract ID',
          filter: { type: 'input', match: 'contains' },
          class: "left",
          width: 8,
        
        },

        duration: {
          name: 'duration',
          type: "Integer",
          label: 'Term',
          filter: { type: 'input', match: 'contains' },
          width: 10,
          class: "left",
        },
        price: {
          name: 'price',
          type: "Integer",
          label: 'New price',
          class: "left",
        }, 
        previous_valid_until: {
          name: 'previous_valid_until',
          type: "String",
          label: 'Previous valid until',
          filter: { type: 'DateRange', match: 'contains'},
          class: "left",
          width: 10,

        }, 
        date_end: {
          name: 'date_end',
          type: "String",
          label: 'New valid until',
          filter: { type: 'DateRange', match: 'contains'},
          class: "left",
          width: 10,

        }, 


        status: {
          name: "status",
          label: "Status",
          type: "Selection",
          custom: 'SelectionText',
          options: [
            {value: 'NEW', label: 'New'},
            {value: 'SUCCESS', label: 'Completed'},
            {value: 'PENDING', label: 'Processing'},
            {value: 'CANCEL', label: 'Cancelled '},
          ],
          filter: {
              type: 'select',
              optionLabel: 'label',
              optionKey: 'value',
              match: 'equals'
          },
          class: "left",
          width : 8,
      },
        created_at : {
          name: 'created_at',
          type: "String",
          label: 'Created date',
          default: 'now()',
          class: "left",
        },
        updated_by: {
          name: 'updated_by',
          type: "Uuid",
          label: 'Updated By',
          width : 10,
          class: "left",
        },
        updated_at: {
            name: 'updated_at',
            type: "String",
            label: 'Updated date',
            class: "left",
        },
      detail_get: {
        refs:  'date_start previous_valid_until name_term rental_order { id  code  }  objec_updated { id fullname } term { id duration  }',
        display: false
      },
      detail_get1: {
        refs:  ' unit_duration ',
        display: false
      },
      }
    );
  }
}
